module.exports = __webpack_public_path__ + "img/c6.820cf7cf.png";